import { getPage } from '~/utils/sanity';
import { generateMetaHead } from '~/utils/head';
import SanityModule from '~/components/sanity/SanityModule.vue';
import SanityPageHeader from '~/components/sanity/SanityPageHeader.vue';
export default {
  components: {
    SanityModule,
    SanityPageHeader
  },
  layout: 'sanity-content',
  data() {
    return {
      page: null,
      seo: null,
      headerLayout: {},
      widgetScript: []
    };
  },
  async fetch() {
    // uses the path to query sanity for page document with same slug
    // example: `/content/credit-talk` without leading slash will retrieve
    // *[_type == "page" && slug.current == "content/credit-talk"]
    const data = await getPage(this.$route.path);
    const {
      page
    } = data;
    this.page = page;
    this.seo = page.seo;
    this.headerLayout = page.headerLayout;
    const findWidgets = this.page.modules.filter(el => {
      return el._type === 'widget';
    });
    if (findWidgets) this.handleWidgets(findWidgets);
  },
  head() {
    let metaHead;
    if (this.seo) metaHead = generateMetaHead({
      title: this.seo && this.seo.metaTitle + ' | Extra',
      description: this.seo.metaDesc,
      image: this.seo.metaImage
    });
    return {
      ...metaHead,
      script: this.widgetScript
    };
  },
  computed: {
    visibleHeader() {
      if (this.headerLayout && 'headerVisible' in this.headerLayout) return this.headerLayout.headerVisible;else return true;
    },
    fixedHeader() {
      if (this.headerLayout && 'headerFixed' in this.headerLayout) return this.headerLayout.headerFixed;else return true;
    }
  },
  methods: {
    handleWidgets(widgets) {
      widgets.forEach(widget => {
        this.widgetScript.push(widget.externalJs ? {
          src: widget.externalJs
        } : '', widget.uploadedFile ? {
          src: widget.uploadedFile,
          body: true
        } : '');
      });
    }
  }
};